import { Atom } from 'AppReact';
import { WebCamComponent } from './webCamComponent';


export default Atom({ type: 'custom', dataType: 'string', template: WebCamComponent });
